import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import {
  Box,
  IconButton,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Edit } from "../../../../../assets/images/edit.svg";
import { ReactComponent as Download } from "../../../../../assets/invoice/material-symbols_download.svg";
import CustomPagination from "../../../../../components/CustomPagination";
import Modal from "../../../../../components/Modal";
import styles from "./style";
import { getDateFormat } from "../../../../../utils/dateFormatStore";

const InvoiceList = ({
  handleDownload,
  total,
  page,
  setPage,
  data,
  handleDelete,
}) => {
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [item, setItem] = useState(null);
  const [opens, setOpens] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleNavigate = () => {
    // Use the latest item state
    if (item) {
      navigate("/dashboard/editInvoice", { state: { item } });
      setAnchorEl(null);
    }
  };

  const handleNavigateView = () => {
    if (item) {
      navigate("/dashboard/viewInvoice", { state: { item, page } });
      setAnchorEl(null);
    }
  };

  const handleClick = (event, rowItem) => {
    setItem(rowItem);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteData = (id) => {
    setDeleteId(id);
    setAnchorEl(null);
    setOpens(true);
  };

  const handleDeleteItem = () => {
    handleDelete(deleteId);
    setOpens(false);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Date</TableCell>
              <TableCell sx={styles.TableHead}>Invoice #</TableCell>
              <TableCell sx={styles.TableHead}>Customer Name</TableCell>
              <TableCell sx={styles.TableHead}>Due Date</TableCell>
              <TableCell sx={styles.TableHead}>Amount</TableCell>
              <TableCell sx={styles.TableHead}>Status</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No Data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tabledata}>
                    {dayjs(item?.invoiceDate).format(getDateFormat())}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    #{item?.invoiceNo}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {item?.customerName}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {dayjs(item?.dueDate).format(getDateFormat())}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {item?.grandTotal.toFixed(2)}
                  </TableCell>
                  <TableCell sx={{ borderBottom: 0 }}>
                    <Box
                      sx={{
                        border: `1px solid ${
                          item.status === "Paid"
                            ? "#28AA4A"
                            : item.status === "Sent"
                            ? "#00ABF4"
                            : item.status === "Draft"
                            ? "#F4B63F"
                            : "black"
                        }`,
                        borderRadius: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        py: "3px",
                        px: "14px",
                        width: "fit-content",
                        fontSize: "12px",
                        color: `${
                          item.status === "Paid"
                            ? "#28AA4A"
                            : item.status === "Sent"
                            ? "#00ABF4"
                            : item.status === "Draft"
                            ? "#F4B63F"
                            : "black"
                        }`,
                      }}
                    >
                      {item?.status}
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
                      <IconButton onClick={(e) => handleClick(e, item)}>
                        <MoreVertIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>

        <CustomPagination
          pageCount={total}
          totalItems={total}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        />
      </TableContainer>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 2, pr: 6 }}>
          <Box>
            <Box sx={styles.iconGrid} onClick={handleNavigate}>
              <Box sx={styles.iconSvg}>
                <Edit />
              </Box>
              <Box sx={styles.iconText}>Edit</Box>
            </Box>
          </Box>
          <Box onClick={handleClose}>
            <Box sx={styles.iconGrid} onClick={handleNavigateView}>
              <Box>
                <RemoveRedEyeOutlinedIcon sx={styles.icon} />
              </Box>
              <Box sx={styles.iconText}>View</Box>
            </Box>
          </Box>

          <Box onClick={handleClose}>
            <Box sx={styles.iconGrid}>
              <Box sx={styles.iconSvg}>
                <Download />
              </Box>
              <Box sx={styles.iconText} onClick={() => handleDownload(item)}>
                Download
              </Box>
            </Box>
          </Box>
          <Box onClick={() => deleteData(item?._id)}>
            <Box sx={styles.iconGrid}>
              <Box>
                <DeleteOutlineIcon sx={styles.icon} />
              </Box>
              <Box sx={styles.iconText}>Delete</Box>
            </Box>
          </Box>
        </Box>
      </Popover>

      <Modal
        open={opens}
        setOpen={setOpens}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Bank"}
        handleDelete={handleDeleteItem}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};
export default InvoiceList;
